module.exports = __webpack_public_path__ + "static/media/4.d1f8a96c.JPG";